jQuery(function ($) {
  // rectangle atf after 3rd post
  if (window.matchMedia("(max-width: 768px)").matches) {
    let $atf = $("#rectangle_atf_mobile");
    let $atf_parent = $atf.parent();
    let $inread_parent = $("#ias-ad-wrapper--3x1");

    $(document).on("tab_changed", function (e) {
      let $current_tab = $(e.target);
      let type = $current_tab.data("type");

      if (
        $("#b-" + type + "-tab--content")
          .children(".b-podcast-content")
          .children(".o-podcast").length > 3
      ) {
        $atf_parent.insertAfter(
          $("#b-" + type + "-tab--content")
            .children(".b-podcast-content")
            .children(".o-podcast")
            .eq(2)
        );
      } else {
        $atf_parent.insertAfter(
          $("#b-" + type + "-tab--content")
            .children(".b-podcast-content")
            .children(".o-podcast")
            .last()
        );
      }
    });

    if ($("body").hasClass("page-template-page-front")) {
      $inread_parent.insertAfter($(".o-post-teaser").eq(5));
    }

    if ($("body").hasClass("page-template-page-streaming-index")) {
      let $mtf = $("#rectangle_mtf");
      let $mtf_parent = $mtf.parent();
      $mtf_parent.insertAfter($(".b-games-calendar"));
    }
  }
});

function hideWidgets() {
  if (window.innerWidth < 480) {
    document.querySelectorAll(".l-sidebar-aside").forEach((widget) => {
      if (widget.querySelector(".ads.ads--center #rectangle_atf")) {
        if (!widget.classList.contains("show-on-mobile")) {
          widget.style.display = "none";
        } else {
          widget.querySelector(
            ".ads.ads--center #rectangle_atf"
          ).parentNode.style.display = "none";
        }
      }
    });
  } else {
    document.querySelectorAll(".widget-ad").forEach((widget) => {
      if (
        widget.querySelector(
          ".section__aside .section__aside-inner .section__aside .section__aside-inner #rectangle_mtf_mobile"
        )
      ) {
        widget.style.display = "none";
      }
      if (
        widget.querySelector(
          ".section__aside .section__aside-inner #rectangle_atf_mobile"
        )
      ) {
        widget.style.display = "none";
      }
    });
  }
}

// Initial check
hideWidgets();

// Re-check on window resize
window.addEventListener("resize", hideWidgets);
